<script>
/**
 * 左ペイン
 * 未割り当てオーダー, ドライバー一覧
 */
import {mapActions} from "vuex";
import ConditionModal from "@/driver/pages/driver_schedules/modals/ConditionModal.vue";
import OrderInstructionModal from "@/driver/pages/driver_schedules/modals/OrderInstructionModal.vue";
import DriverSettingModal from "@/driver/pages/driver_schedules/modals/DriverSettingModal.vue";
import EditOrderModal from "@/driver/pages/driver_schedules/modals/EditOrderModal.vue";
import OrderDetailModal from "@/driver/pages/driver_schedules/modals/OrderDetailModal.vue";
import draggable from 'vuedraggable'
import utilMixins from '../../../mixins/utils';

export default {
  name: "ScheduleSearchBlock",
  components: {
    ConditionModal,
    draggable,
    OrderInstructionModal,
    DriverSettingModal,
    OrderDetailModal,
    EditOrderModal,
  },
  mixins: [utilMixins],
  props: {
    /**
     * ドライバー一覧
     */
    drivers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /** 検索日 */
      searchDate: this.$dayjs().format('YYYY-MM-DD'),
      /** 検索条件 */
      conditions: {},
      /** 検索結果 */
      schedules: [],
      /** 運搬担当者 チェックボックス */
      checkable: true,
      enableOrderInstructionModal: false,
      enableDriverSettingModal: false,
      enableOrderDetailModal: false,
      enableEditOrderModal: false,
      choseOrderId: null,
      choseOrderType: null,
      isResizing: false,
      startY: 0,
      startHeight: 0,
      orderSectionHeight: 0,  // 初期値を0に
      driverSectionHeight: 0, // 初期値を0に
    }
  },
  computed: {
    driverIndeterminate() {
      const showables = this.drivers.filter(driver => driver.showable);
      return showables.length > 0 && showables.length < this.drivers.length;
    }
  },

  watch: {
    drivers: {
      deep: true,
      handler() {
        this.transferDisabledDrivers();
      }
    },
    /**
     * ドライバーブロック
     * 運搬担当者チェックボックスの監視
     */
    checkable () {
      this.checkableClickEvent();
    }
  },
  mounted() {

    // 初期化
    this.initializeHeights();

    // リサイズイベントのリスナーを追加
    window.addEventListener('resize', this.handleResize);

    // 念のため少し遅らせてもう一度初期化
    setTimeout(() => {
      this.initializeHeights();
    }, 100);
  },

  created() {
    this.conditionModalCallback({});
  },
  methods: {
    ...mapActions('DriverScheduleUnassignedOrder', {
      fetchSchedules: 'index',
    }),
    /**
     * 本ブロックの高さの調整
     */
    initializeHeights() {
      this.$nextTick(() => {
        const container = this.$refs.resizableContainer;
        if (!container) {
          return;
        }

        // コンテナの実際の高さを取得
        const containerHeight = container.clientHeight;
        if (!containerHeight) {
          return;
        }

        const minSectionHeight = 100; // 各セクションの最小高さ
        const handleHeight = 15; // ハンドルの高さ

        // 初期の高さを設定（例: 70%を注文一覧に、残りをドライバー一覧に）
        const initialOrderHeight = containerHeight * 0.7;

        // 最小高さを保証
        this.orderSectionHeight = Math.max(minSectionHeight, initialOrderHeight);
        this.driverSectionHeight = Math.max(
          minSectionHeight,
          containerHeight - this.orderSectionHeight - handleHeight
        );
      });

    },

    /**
     * 前日ボタン クリックイベント
     */
    previousButtonClickEvent () {
      this.searchDate = this.$dayjs(this.searchDate).add(-1, 'days').format('YYYY-MM-DD')
      this.conditionModalCallback(this.conditions);
    },
    /**
     * 翌日ボタン クリックイベント
     */
    nextButtonClickEvent () {
      this.searchDate = this.$dayjs(this.searchDate).add(1, 'days').format('YYYY-MM-DD')
      this.conditionModalCallback(this.conditions);
    },
    checkableClickEvent () {
      this.checkableChangeEvent();
    },
    /**
     * 受注カード
     * 受注編集メニュー クリックイベント
     * @param schedule
     */
    editOrderMenuClickEvent (schedule) {
      this.choseOrderId = schedule.order_id;
      this.choseOrderType = schedule.order_type
      this.enableEditOrderModal = true;

    },
    /**
     * 受注カード
     * 詳細を参照メニュー クリックイベント
     * @param schedule
     */
    showDetailMenuClickEvent (schedule) {
      this.choseOrderId = schedule.order_id;
      this.choseOrderType = schedule.order_type
      this.enableOrderDetailModal = true;
    },
    /**
     * 受注カード
     * 指示メモ編集ボタン クリックイベント
     * @param evt
     * @param schedule
     */
    orderInstructionMenuClickEvent (evt, schedule) {
      this.choseOrderId = schedule.order_id;
      this.enableOrderInstructionModal = true;
    },
    /**
     * 受注カード
     * ドライバー設定メニュー クリックイベント
     * @param evt
     * @param schedule
     */
    driverSettingMenuClickEvent(evt, schedule) {
      this.choseOrderId = schedule.order_id;
      this.enableDriverSettingModal = true;
    },
    onStart() {
      // ドラッグ中にカーソルを変更
      setTimeout(() => {
        window.document.body.classList.add('grabbing');
        window.document.body.style.cursor = 'grabbing';
      }, 100)
    },
    onEnd() {
      // ドラッグ終了後にカーソルをデフォルトに戻す
      window.document.body.style.cursor = '';
      window.document.body.classList.remove('grabbing');
    },
    /**
     * カードの移動イベント
     * @param evt
     * @returns {boolean}
     */
    // handleMove(evt, originalEvent) {
    handleMove(evt) {
      const draggedElement = evt.draggedContext.element;

      // const relatedElement = evt.relatedContext.element;
      // const relatedScheduleType = relatedElement?.schedule_type;
      // 移動先が指示カードの後ろであれば移動させない。
      // if (relatedScheduleType === 'instruction') {
      //   return false;
      // }

      const relatedTargetDate = evt.relatedContext.component.$attrs.group.targetDate;

      // 移動元の引渡日と移動先の日付が不一致の場合は移動させない。
      /**
       * 選択したカードに日付ありで、移動先の日付と一致しない場合
       */
      if (draggedElement.plan_date !== null && draggedElement.plan_date !== relatedTargetDate) {
        return false;
      }
    },
    /**
     * 検索条件変更 コールバック
     * @param conditions { Object }
     */
    conditionModalCallback (conditions) {
      this.conditions = conditions;
      this.searchSchedules();
    },
    /**
     * 検索処理の実行
     */
    searchSchedules () {
      this.schedules = []
      const params = {
        ...this.conditions,
        target_date: this.searchDate
      }
      this.fetchSchedules({conditions: params}).then((response) => {
        this.schedules = response.orders;
      });

    },
    /**
     * チェックが外されたドライバーIDを特定し読み込み元にコールバック
     */
    transferDisabledDrivers () {
      const disabledDriverIds = this.drivers.filter(driver => driver.showable === false).map(driver => driver.value);
      if (disabledDriverIds.length === 0) {
        this.checkable = true;
      }
      this.$emit('disableDriverCallback', disabledDriverIds);
    },
    /**
     * チェックボックス変更イベント
     */
    checkableChangeEvent () {
      this.drivers.forEach(driver => {
        driver.showable = this.checkable;
      });
    },
    /**
     * 日付変更コールバック
     * @param date
     */
    dateChangedCallback (date) {
      this.searchDate = date
      this.conditionModalCallback(this.conditions);
    },
    /**
     * モータルを閉じるコールバック
     */
    closeModalCallback () {
      this.enableOrderInstructionModal = false
      this.enableDriverSettingModal = false
      this.enableOrderDetailModal = false
      this.enableEditOrderModal = false

      this.choseOrderId = null
      this.choseOrderType = null
    },
    /**
     * 詳細を参照モーダル
     * ドライバースケジュールのリフレッシュ
     */
    orderDetailRefreshCallback () {
      // 左ペイン一覧のリロード
      this.searchSchedules();
      // 右ペインのリロード
      this.$emit('callScheduleBlock')

    },
    /**
     * ドライバー指示メモ
     * 登録後のコールバック
     */
    orderInstructionModalRegisterCallback () {
      this.closeModalCallback();
    },
    /**
     * ドライバー設定
     * 登録後のコールバック
     */
    driverSettingModalRegisterCallback() {
      // 左ペイン一覧のリロード
      this.searchSchedules();
      // 右ペインのリロード
      this.$emit('callScheduleBlock')
      this.closeModalCallback();
    },
    startResize(e) {
      this.isResizing = true;
      this.startY = e.clientY;

      // 現在の表示されている高さを正確に取得
      const orderSection = this.$refs.orderSection;
      if (orderSection) {
        this.startHeight = orderSection.offsetHeight;
      } else {
        this.startHeight = this.orderSectionHeight;
      }

      document.body.style.cursor = 'row-resize';
      document.body.style.userSelect = 'none';

      // マウスアップイベントを追加
      const stopResize = () => {
        this.stopResize();
        document.removeEventListener('mouseup', stopResize);
      };
      document.addEventListener('mouseup', stopResize);
    },
    onMouseMove(e) {
      if (!this.isResizing) return;

      const container = this.$refs.resizableContainer;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const containerHeight = containerRect.height;
      const minSectionHeight = 100; // 各セクションの最小高さ
      const handleHeight = 10; // ハンドルの高さ

      // マウスの移動量を計算
      const deltaY = e.clientY - this.startY;

      // 現在の高さをベースに新しい高さを計算
      const newOrderHeight = this.startHeight + deltaY;

      // 高さの制限を設定（最小値と最大値）
      const maxOrderHeight = containerHeight - minSectionHeight - handleHeight;
      const clampedOrderHeight = Math.max(minSectionHeight, Math.min(newOrderHeight, maxOrderHeight));

      // 高さを更新
      this.orderSectionHeight = clampedOrderHeight;
      this.driverSectionHeight = containerHeight - clampedOrderHeight - handleHeight;
    },

    stopResize() {
      this.isResizing = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    },
    handleResize () {
      const container = this.$refs.resizableContainer;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const containerHeight = containerRect.height;
      const minHeight = 100;
      const maxOrderHeight = containerHeight - minHeight - 10;

      // 現在の高さを制限
      this.orderSectionHeight = Math.max(
        minHeight,
        Math.min(this.orderSectionHeight, maxOrderHeight)
      );
      this.driverSectionHeight = containerHeight - this.orderSectionHeight - 10;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.stopResize();
  },
}
</script>
<template>
  <div
    class="resizable-container"
    ref="resizableContainer"
    @mousemove="onMouseMove"
    @mouseup="stopResize"
    @mouseleave="stopResize"
    style="display: flex; flex-direction: column;"
  >
    <!-- 受注一覧 -->
    <div
      class="resizable-section"
      ref="orderSection"
      :style="{
      height: `${orderSectionHeight}px`,
      minHeight: '100px',
      maxHeight: `calc(100% - 110px)` /* ドライバーセクションの最小高さ + ハンドル分 */
      }"
    >
      <v-card flat outlined class="h-100 d-flex flex-column">
      <v-card-text class="px-1 pb-0 py-1">
        <div class="text-center">
          <small>受注一覧（運搬担当者・日付未定）</small>
        </div>
        <div class="my-2 text-center">
          <v-btn
            color="primary"
            icon
            small
            @click="previousButtonClickEvent"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <cs-date-picker
            :date.sync="searchDate"
            @dateChangedCallback="dateChangedCallback"
          >
            <template v-slot:default="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
              >
                <strong>{{ searchDate | date_format }}</strong>
              </v-btn>
            </template>
          </cs-date-picker>
          <strong
            v-if="false"
          >&nbsp;{{ searchDate | date_format }}&nbsp;</strong>
          <v-btn
            color="primary"
            icon
            small
            @click="nextButtonClickEvent"
          >
            <v-icon >mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div class="mx-1">
          <condition-modal @searchCallback="conditionModalCallback" />
        </div>
        <div class="mt-1 text-center">
          <v-icon x-small>mdi-plus</v-icon>
          <span style="font-size: 0.5rem;">ドラッグ＆ドロップしてドライバーに追加</span>
        </div>
      </v-card-text>

      <!-- 検索結果 -->
      <v-card-text
        class="pt-1 flex-grow-1"
        style="overflow-y: auto; padding-left: 8px; padding-right: 8px;"
      >
        <draggable
          v-model="schedules"
          :group="{ name: 'schedules', pull: true, put: false }"
          :sort="false"
          :move="handleMove"
          ghost-class="schedule-card-ghost"
          @start="onStart"
          @end="onEnd"
        >
          <transition-group
            type="transition"
            name="flip-list"
            tag="div"
            style="min-height: 28vh;"
          >
            <v-card
              v-for="schedule in schedules"
              :key="schedule.order_id"
              class="mb-1"
              :style="(!schedule.reserved && ['collection', 'general'].includes(schedule.order_type)) ? 'border: 1px dashed #bdbdbd !important;' : ''"
              flat
              rounded
              outlined
            >
              <v-toolbar
                flat
                dense
                height="24"
                class="schedule-title"
              >
                <v-toolbar-title class="pb-2">
                  <span style="font-size: 0.7rem;">{{ schedule.order_type_label }}: {{ dsOrderRequestNumber(schedule) }}</span>
                </v-toolbar-title>
                <v-spacer />
                <v-menu
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                    >
                      <v-icon small>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <!-- 0: collection_requested: 産廃回収（未受付） -->
                    <!-- 1: collection_accepted: 産廃回収（受注） -->
                    <!-- 4: collection_transported: 産廃回収（運搬完了） -->
                    <v-list-item
                      v-if="['collection_requested', 'collection_accepted', 'collection_transported'].includes(schedule.status)"
                      @click="editOrderMenuClickEvent(schedule)"
                    >
                      <v-list-item-title>受注編集</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-else @click="showDetailMenuClickEvent(schedule)">
                      <v-list-item-title>詳細を参照</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="orderInstructionMenuClickEvent($event, schedule)">
                      <v-list-item-title>指示メモを編集</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="driverSettingMenuClickEvent($event, schedule)">
                      <v-list-item-title>運搬設定を変更</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-divider light />
              <v-card-text class="pb-0 pt-1" style="padding-left: 8px; padding-right: 8px;">
                <div
                  class="text-ellipsis"
                  style="line-height: 15px;"
                  :title="`受注番号: ${ schedule.order_no}\n引取搬入番号: ${ schedule.request_no || ''}\n${schedule.emission_name || ''}\n${schedule.emission_location_name || ''}\n${schedule.emission_location_address || ''}\n${schedule.item_name || ''}`"
                >
                  <span class="black--text" style="font-size: 0.65rem">{{ schedule.emission_location_name }}</span>
                </div>
                <div
                  class="text-ellipsis primary--text"
                  style="line-height: 15px;"
                  :style="`padding-bottom: ${ schedule.plan_date || schedule.plan_end_time ? 0 : '4px' };`"
                  :title="`${schedule.dispose_name || ''}\n${schedule.dispose_location_name || ''}\n${schedule.dispose_location_address || ''}`"
                >
                  <span style="font-size: 0.6rem">{{ schedule.dispose_location_name }}</span>
                </div>
                <div style="line-height: 15px;">
                  <span class="black--text" style="font-size: 0.6rem" v-if="schedule.plan_date">{{ schedule.plan_date | date_format }}&nbsp;</span>
                  <span class="black--text" style="font-size: 0.6rem" v-if="schedule.plan_start_time || schedule.plan_end_time">
                  {{ schedule.plan_start_time }}〜{{ schedule.plan_end_time }}
                  </span>
                </div>
              </v-card-text>
            </v-card>
          </transition-group>
        </draggable>
      </v-card-text>
      </v-card>
    </div>
    <!-- /受注一覧 -->

    <!-- リサイザー -->
    <div
      class="resize-handle"
      @mousedown="startResize"
    >
      <v-icon style="font-size:14px;color:#bdbdbd">mdi-view-sequential</v-icon>
    </div>
    <!-- /リサイザー -->

    <!-- ドライバー一覧 -->
    <div
      class="resizable-section"
      :style="{
        height: `${driverSectionHeight}px`,
        minHeight: '100px',
        maxHeight: '100%',
        flex: '0 0 auto',
        display: 'flex',
        flexDirection: 'column'
      }"
    >
      <v-card flat outlined class="h-100 d-flex flex-column">
        <v-card-text class="py-0 pl-1 pr-1">
          <v-list
            dense
            flat
            style="padding-top: 5px;padding-bottom: 5px;"
          >
            <v-list-item
              dense
              class="px-0"
              style="min-height: 30px !important;"
            >
              <template>
                <v-list-item-action class="my-0 ml-2 mr-2">
                  <v-checkbox
                    v-model="checkable"
                    :indeterminate="driverIndeterminate"
                    dense
                  />
                </v-list-item-action>
                <v-list-item-content @click="checkable = !checkable" style="cursor: pointer;">
                  <v-list-item-title>運搬担当者</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-text
          class="py-1 pl-1 pr-1"
          style="overflow-y: scroll;"
        >
          <v-list
            dense
            flat
            class="pt-1 mt-1"
          >
            <v-list-item
              v-for="driver in drivers"
              :key="driver.value"
              dense
              class="px-0"
              style="min-height: 30px !important;"
            >
              <v-list-item-action class="my-0 ml-2 mr-2">
                <v-checkbox
                  v-model="driver.showable"
                  class="pr-0"
                  dense
                />
              </v-list-item-action>
              <v-list-item-content @click="driver.showable = !driver.showable" style="cursor: pointer;">
                <v-list-item-title>{{ driver.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>

    </div>
    <!-- /ドライバー一覧 -->

    <!-- 受注編集 -->
    <edit-order-modal
      :enable-dialog="enableEditOrderModal"
      :order-id="choseOrderId"
      :order-type="choseOrderType"
      @closeCallback="closeModalCallback"
      @registerCallback="orderDetailRefreshCallback"
    />
    <!-- /受注編集 -->

    <!-- 詳細を参照 -->
    <order-detail-modal
      :enable-dialog="enableOrderDetailModal"
      :order-id="choseOrderId"
      :order-type="choseOrderType"
      @closeCallback="closeModalCallback"
      @modalRefreshCallback="orderDetailRefreshCallback"
    />
    <!-- /詳細を参照 -->

    <!-- ドライバー指示メモを編集 -->
    <order-instruction-modal
      :enable-dialog="enableOrderInstructionModal"
      :order-id="choseOrderId"
      @closeCallback="closeModalCallback"
      @registerCallback="orderInstructionModalRegisterCallback"
    />
    <!-- /ドライバー指示メモを編集 -->

    <!-- ドライバー設定 -->
    <driver-setting-modal
      :enable-dialog="enableDriverSettingModal"
      :order-id="choseOrderId"
      :drivers="drivers"
      @closeCallback="closeModalCallback"
      @registerCallback="driverSettingModalRegisterCallback"
    />
    <!-- /ドライバー設定 -->

  </div>
</template>
<style scoped lang="scss">
.resizable-container {
  height: 100%;
  //min-height: calc(100vh - 380px);
  max-height: calc(100vh - 210px);
  display: flex;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.resizable-section {
  /*
  overflow: hidden;
  transition: height 0.2s ease;
*/
  flex: 0 0 auto;
  overflow-y: auto;
  min-height: 100px;
  box-sizing: border-box;

}

/* 受注一覧セクション */
.resizable-section:first-child {
  flex: 1 1 auto;
  min-height: 200px;
}

/* ドライバー一覧セクション */
.resizable-section:last-child {
  flex: 0 0 auto;
  min-height: 100px;
}

.resize-handle {
  height: 10px;
  cursor: row-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
}

.resize-handle:hover {
  background-color: #00AAD1;
}

.h-100 {
  height: 100%;
}

.flex-grow-1 {
  flex-grow: 1;
}

.d-flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}
</style>
